import React, { memo } from "react";
import Modal from "@mui/material/Modal";
import PropTypes from "prop-types";

import AppButton from "components/app-button";

const AppInactivityLogoutModal = ({ visible, onHandleConfirm }) => {
	return (
		<Modal classes={{ root: "app-inactivity-logout-modal" }} open={visible} aria-labelledby="app-inactivity-logout" aria-describedby="app-inactivity-logout">
			<div className="inactivity-logout-modal">
				<div className="inactivity-logout-modal__header">
					<p className="inactivity-logout-modal__title">Session Timed Out</p>
					<p className="inactivity-logout-modal__description">You have been signed out due to inactivity. Please log in again to continue.</p>
				</div>

				<div className="inactivity-logout-modal__button-container">
					<AppButton type="button" label="OK" onClick={onHandleConfirm} />
				</div>
			</div>
		</Modal>
	);
};

AppInactivityLogoutModal.propTypes = {
	visible: PropTypes.bool.isRequired,
	onHandleConfirm: PropTypes.func.isRequired,
};

export default memo(AppInactivityLogoutModal);
